"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Persona", {
    enumerable: true,
    get: function() {
        return Persona;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _renderPersona = require("./renderPersona");
const _usePersona = require("./usePersona");
const _usePersonaStylesstyles = require("./usePersonaStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const Persona = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _usePersona.usePersona_unstable)(props, ref);
    (0, _usePersonaStylesstyles.usePersonaStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('usePersonaStyles_unstable')(state);
    return (0, _renderPersona.renderPersona_unstable)(state);
});
Persona.displayName = 'Persona';
